import { gql } from "@apollo/client";

export const GET_ALL_GROUPS_WHERE = gql`
  query GetUserGroupsWhere($where: UserGroupWhereInput) {
    getUserGroupsWhere(where: $where) {
      id
      name
    }
  }
`;

export const GET_ALL_GROUPS = gql`
  query GetAllGroups(
    $where: UserGroupWhereInput
    $take: Int
    $skip: Int
    $orderBy: [UserGroupOrderByWithRelationInput!]
  ) {
    getAllGroups(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
      id
      name
    }
  }
`;

export const GET_GROUP_BY_ID = gql`
  query GetUserGroupsWhereUnique($where: UserGroupWhereUniqueInput!) {
    getUserGroupsWhereUnique(where: $where) {
      id
      name
      groupType
      status
      clinicNumber
      pickupCarrier
      deliveryCarrier
      phoneNumber
      description
      threeDModelPricingType
      exemptOriginalAbutmentCharge
      hidePricesOnPractitionerTraceability
      createdBy {
        firstName
        lastName
      }
      clientBilling {
        id
        pricingType
      }
      availableProvider {
        id
        provider {
          id
          name
        }
      }
      groupMembers {
        email
        firstName
        lastName
        id
        isManager
      }
      addresses {
        city
        name
        country
        id
        streetName
        streetNumber
        details
        postcode
      }
    }
  }
`;

export const CREATE_GROUP = gql`
  mutation CreateUserGroup(
    $args: UserGroupCreateInput!
    $providerGroupIds: [String!]!
  ) {
    createUserGroup(args: $args, providerGroupIds: $providerGroupIds) {
      id
    }
  }
`;

export const UPDATE_USER_GROUP = gql`
  mutation UpdateUserGroup(
    $data: UserGroupUpdateInput!
    $where: UserGroupWhereUniqueInput!
    $providerGroupIds: [String!]!
  ) {
    updateUserGroup(
      data: $data
      where: $where
      providerGroupIds: $providerGroupIds
    ) {
      id
    }
  }
`;

export const CHECK_BIP_CONFIGURATION = gql`
  query CheckBipConfiguration($clinicNumber: String!) {
    checkBipConfiguration(clinicNumber: $clinicNumber)
  }
`;
